import React from 'react'

import { Form, Col, Button } from '_zari/core'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

const FechaFormGroup = ({ value, onChange, setFecha }) => {
  const buscarFechaClick = () => {
    FacturacionHistorialService.obtenerPrimerPendienteResumenNotas().then(({ data }) => {
      setFecha(data.fecha)
    })
  }

  return (
    <Form.Group>
      <Col md={4} className='text-right'>
        <Button color='warning' onClick={buscarFechaClick}>
          Buscar fecha pendiente
        </Button>
      </Col>
      <Col md={8}>
        <Form.InputDate name='inputFecha' value={value} onChange={onChange} id='input-fecha-resumen-notas' />
      </Col>
    </Form.Group>
  )
}

export default FechaFormGroup
